import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';
import FileIcon from '../FileIcon';

const Thumbnail = ({uri = '', fileExtension = '', fileToSave}) => {
  const link = `data:image/png;base64,${uri}`;

  return (
    <div className={classnames(styles.container, {[styles.pdfContainer]: fileExtension === 'pdf'})}>
      {uri && !fileToSave
        ? <img src={link} alt={'thumbnail'}/>
        : <div className={styles.defContainer}><FileIcon fileExtension={fileExtension}/></div>
      }
    </div>
  );
};

export default Thumbnail;
